import { returnBill, validateAddBills, addBills, parseBillsObject } from '../../actions/purchaseActions';
import { errorHardware } from '../../actions/maintenanceActions';
import { sendErrorPurch } from '../../actions/machineActions';
import { setBABusyFalse, setBABusyTrue } from '../../actions/billAcceptorActions';
import { lightOff } from '../../actions/lightActions';
import { lockExit } from '../../actions/purchaseActions';

import { track } from '../../helpers/analytics';

let message;
const $ = window.$;

export default function billAcceptorMM(action, store, _hub, next){

  switch(action.type){

    case 'CANCEL_INS_BILL':
      store.dispatch(lightOff("BAS"))
      _hub.server.cS_BAS_CancelWait().done(response=>{
      })
      .fail(err=> {
        store.dispatch(errorHardware(err))
      });
      break;

    case 'CHECK_LAST_BOX_STATE': //need to register it in actions
      _hub.server.cS_BAS_LastKnownCashBoxState().done(response=>{
      })
      .fail(err=> {
        store.dispatch(errorHardware(err))
      });
      break;

    case 'RETURN_BILL':
      _hub.server.cS_BAS_Return().done(response=>{
        if(store.getState().router.location.pathname === '/insert_cash') {
          store.dispatch({ type: 'INSERT_BILL', signalR: true})
          if(message) {
            store.dispatch({ type: "ERROR_PURCHASE", message: message})
          }
        }
        store.dispatch(setBABusyFalse())
      })
      .fail(err=> {
        store.dispatch(errorHardware(err))
      });
      message = action.message;
      break;

    case 'STACK_BILL':
      _hub.server.cS_BAS_Stack().done(res=>{
        if(!res.HardwareResult){                // NO ERROR IN HARDWARE ( res.HardwareResult === 0)
          // We have a Denomination and ValidatorState === 2 (Stacked) (It's in the bill acceptor)
          if (res.Data.Denomination && res.Data.ValidatorState === 2){
            let p1 = res.Data.Denomination  // bill inserted denomination
            store.dispatch(addBills(parseBillsObject(p1)))  // add bills to backend
          }
          else {
            store.dispatch(sendErrorPurch(res))
          }
        }
        else
          store.dispatch(sendErrorPurch(res))
      })
      .fail(err=> {
        store.dispatch(errorHardware(err))
      });
      store.dispatch(lockExit())
      break;

    case 'FUNDS_ADDED':
      store.dispatch({ type: "INSERT_BILL", signalR: true})
      break

    case 'INSERT_BILL':
      store.dispatch(setBABusyFalse())
      _hub.server.cS_BAS_Wait().done(res=>{
        store.dispatch(setBABusyTrue())
        setTimeout(() => {
          if(store.getState().billAcceptor.isBusy){
            baWaitResponse(res, store)
          } else {
            store.dispatch(returnBill())
          }
        }, 500)
      })
      .fail(err=> {
        store.dispatch(errorHardware(err))
      });
      break;

    default:
      next()
  }
}

function baWaitResponse(res, store){
  if(store.getState().machine.name === 'rick'){   //IF MACHINE IS A RICK
    let event = new Event('inserted', { bubbles: true });
      $("body")[0].dispatchEvent(event);
    if(!res.HardwareResult){                      // NO ERROR IN HARDWARE ( res.HardwareResult === 0)
      // We have a Denomination and ValidatorState === 1 (Escrowed) (It's in the bill acceptor)
      if (res.Data.Denomination && res.Data.ValidatorState === 1){
        let p1 = res.Data.Denomination // bill inserted denomination
        if(store.getState().purchase.num_bills < 1) {
          track('First Bill Inserted');
        }
        store.dispatch(validateAddBills(parseBillsObject(p1)))  // validate add bills
      }
      else{
        if(res.Data.ValidatorState !== 20 || res.HardwareResult)  //!== Canceled or hardware error > 0
          store.dispatch(sendErrorPurch(res))
        if(res.MetaData.Reason === "Canceled" || res.MetaData.Description === "Canceled"){
        }
        else{
          store.dispatch({ type: 'INSERT_BILL', signalR: true})
        }
      }
    }
    else
      console.error('There was a wait already')
  }
}
